import React, { useEffect, useState } from "react";
import Loadable from "react-loadable";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";

import "./app.less";

import HeaderContainer from "containers/widgets/header";
import SplashScreen from "./widgets/splashscreen/splashscreen";

import { firebaseConfig } from "utils/firebase";
import * as firebase from "firebase/app";
import "firebase/analytics";
import CookiesBar from "./widgets/cookiesbar/cookiesbar";


const Modal = Loadable({
  loader: () => import("containers/modules/modal"),
  loading: () => ("<div>Loading...</div>"),
});

const Footer = Loadable({
  loader: () => import("containers/widgets/footer"),
  loading: () => ("<div>Loading...</div>"),
});

firebase.initializeApp(firebaseConfig);


const App = ({ modal, params, t, children }) => {
  const [isShownSplashScreen, setIsShownSplashScreen] = useState(true);

  const handleCompleteSplashScreen = () => {
    setIsShownSplashScreen(false);
  };


  // /**
  //  * Shows error dialog.
  //  */
  // showConfigError (errorMessage) {
  //    let store = getStore(),
  //         { t } = this.context
  //
  //    const remoteConfigCondition =
  //       errorMessage === ErrorMessages.REMOTE_CONFIG &&
  //       navigator.userAgent.includes('Firefox');
  //
  //    const errorHeaderMessage = remoteConfigCondition
  //       ? t('settings.errors.config-error-incognito.header')
  //       : t('settings.errors.config-error.header');
  //    const errorDescriptionMessage = remoteConfigCondition
  //       ? t('settings.errors.config-error-incognito.description')
  //       : t('settings.errors.config-error.description');
  //
  //     store.dispatch(setModalStatus(ModalStatus.SHOW));
  //     store.dispatch(setConfirmModalData(
  //        errorHeaderMessage,
  //        errorDescriptionMessage,
  //         () => {
  //             store.dispatch(hideModal());
  //         }
  //     ));
  //     store.dispatch(setModalType(ModalTypes.CONFIRM));
  //     store.dispatch(showModal());
  // }

  return (
    <div className="app container">
      <Helmet>
        <title>
          ביגי - עולם ענק ומרגש של תוכן איכותי לילדים ונוער - BIGI
        </title>
        <meta
          name="description"
          content="אנחנו BIGI עולם תוכן ענקייי לילדים ונוער! צפייה ישירה מכל מקום בסדרות ותוכניות אהובות, תכנים בלעדיים של כוכבי רשת ועוד ים של הפתעות!  BIGI בואנ'ה זה ענק!"
        />
      </Helmet>
      <CookiesBar />
      <HeaderContainer />
      <div id="routeContent">
        {isShownSplashScreen && (
          <SplashScreen
            handleComplete={handleCompleteSplashScreen}
          />
        )}
        {children}
      </div>
      <Footer />
      {modal.show && <Modal {...modal} params={params} />}
    </div>
  );
};


App.propTypes = {
  t: PropTypes.func,
  modal: PropTypes.object,
  params: PropTypes.object,
  children: PropTypes.node,
};

export default App;



// WEBPACK FOOTER //
// ./src/js/components/app.jsx